import React from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';

import MarketOverviewCard from './MarketOverviewCard';
import AppsLine from '../AppsLine';
import SectionSummary from '../../../_shared/components/SectionSummary';
import { aiDashboardAppsSelector, aiMarketOverviewSelector } from '../../selectors';

const MarketOverview = ({ allowQV, isPress }) => {
  const apps = useSelector(aiDashboardAppsSelector);
  const marketOverview = useSelector(aiMarketOverviewSelector);

  return (
    <div className="market-overview">
      <SectionSummary
        title="Market Overview"
        description="Track the growth of DAUs and Downloads of the AI app market. See which apps are taking share."
      >
        <AppsLine apps={apps.data?.apps} settings={apps.settings} allowQV={allowQV} />
      </SectionSummary>
      <MarketOverviewCard
        marketOverview={marketOverview}
        apps={apps.data?.apps}
        isAppsPending={apps.settings.pending}
        isPress={isPress}
      />
    </div>
  );
};

MarketOverview.propTypes = {
  allowQV: T.bool.isRequired,
  isPress: T.bool,
};

export default MarketOverview;
